import request from '../libs/request';

const res = 'I18nText';

export default {
  queryForEdit(i18nType, category) {
    return request({
      url: `api/${res}/queryForEdit`,
      method: 'get',
      params: {
        i18nType,
        category
      }
    });
  },
  save(i18nType, category, data) {
    return request({
      url: `api/${res}/save`,
      method: 'post',
      data: {
        i18nType,
        category,
        data
      }
    });
  },
  getAll() {
    return request({
      url: `api/${res}/getAll`,
      method: 'get'
    });
  }
};
